<template>
  <v-container class="wrapper">
    <div class="offer-content">
      <p class="offer-text">
        {{ $t('COMMON.PRODUCT_END_STATUS.' + selectedRepairerOffer.offer_type.toUpperCase()) }}
      </p>
      <p class="offer-text">
        {{
          selectedRepairerOffer.total_cost.toFixed(2) +
          $t('COMMON.EURO') +
          $t('COMMON.EXCLUSIVE_TAX')
        }}
      </p>
    </div>
    <p class="title">{{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.TITLE') }}</p>
    <p class="text">
      {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.SUB_TITLE.CONTACT_REPAIRER') }}
    </p>
    <div class="line-content" />
    <div class="info-content">
      <img alt="cost-icon" class="icon" src="@/assets/icons/file/currency-eur.svg" />
      <p class="text">
        {{ repairerPrice.toFixed(2) + $t('COMMON.EXCLUSIVE_TAX') }}
      </p>
    </div>
    <div class="info-content">
      <img alt="phone-icon" class="icon" src="@/assets/icons/file/phone.svg" />
      <p class="text">{{ repairerCenterPhoneNumber }}</p>
    </div>
    <div class="info-content">
      <img alt="mail-icon" class="icon" src="@/assets/icons/file/mail.svg" />
      <p class="text">{{ repairerCenterEmail }}</p>
    </div>
    <p class="text margin-top-10">
      {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.SUB_TITLE.CONTACT_CLIENT') }}
    </p>
    <div class="line-content" />
    <div class="info-content">
      <img alt="phone-icon" class="icon" src="@/assets/icons/file/phone.svg" />
      <p class="text">{{ customerPhoneNumber }}</p>
    </div>
    <div class="info-content">
      <img alt="mail-icon" class="icon" src="@/assets/icons/file/mail.svg" />
      <p class="text">{{ customerEmail }}</p>
    </div>
    <div class="bottom-content">
      <v-col cols="12" class="px-0">
        <v-btn
          class="boom-button w-100"
          :disabled="loading"
          :loading="loading"
          variant="outlined"
          @click="submit"
        >
          {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.BUTTON.SAVE') }}
        </v-btn>
      </v-col>
      <v-btn
        class="button w-100"
        :loading="loading"
        variant="outlined"
        @click="$emit('cancelEstimateRepairer')"
      >
        {{ $t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.BUTTON.CANCEL') }}
      </v-btn>
    </div>
  </v-container>
</template>
<script>
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import RepairFileService from '@/services/RepairFileService'
import { auth as $store } from '@/store/AuthModule'
import RepairCenterService from '@/services/RepairCenterService'

export default {
  props: {
    currentRepairFile: Object
  },
  data() {
    return {
      loading: false,
      error: null,

      repairerPrice: null,
      selectedRepairerOffer: null,
      repairerCenterPhoneNumber: null,
      repairerCenterEmail: null,
      customerPhoneNumber: null,
      customerEmail: null
    }
  },
  async created() {
    await this.patchData()
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        const data = {
          requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
          repair_file_id: this.currentRepairFile.technical_id,
          repairer_estimate_option_id: this.selectedRepairerOffer.technical_id,
          margin: this.selectedRepairerOffer.margin,
          total_cost: this.selectedRepairerOffer.total_cost
        }
        await RepairFileService.saveRepairerEstimateOptionClientChoiceFromManualSelection(data)
        displayToast(this.$t('ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION.VALIDATION'), 'success')
        this.$emit('updateCurrentRepairFile')
        this.$emit('cancelEstimateRepairer')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getRepairCenter() {
      const response = await RepairCenterService.getRepairCenterDetailByRepairFile(
        this.currentRepairFile.technical_id
      )
      this.repairerCenterPhoneNumber = response.phone_number
      this.repairerCenterEmail = response.contact_email
    },
    async patchData() {
      this.selectedRepairerOffer =
        this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.find(
          (repairerOffer) => repairerOffer.is_selected === true
        )
      this.customerPhoneNumber = this.currentRepairFile.phone_number
      this.customerEmail = this.currentRepairFile.email
      this.repairerPrice =
        this.selectedRepairerOffer.estimate_cost + this.selectedRepairerOffer.transport_cost
      await this.getRepairCenter()
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    }
  }
}
</script>

<style scoped>
.title {
  margin-bottom: 20px;
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.text {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.button {
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  text-transform: none !important;
  border-radius: 20px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.bottom-content {
  margin-top: auto;
}

.line-content {
  width: 100%;
  margin: 10px 0 10px 0;
  border-top: 1px solid black;
}

.boom-button {
  padding: 10px 20px !important;
}

.offer-content {
  margin-bottom: 20px;
  justify-content: space-between;
  display: flex;
  padding: 20px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid #559a1b;
  background: #559a1b;
}

.offer-text {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.info-content {
  display: flex;
  align-items: center;
  margin: 10px 0 10px 20px;
}

.icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}

.margin-top-10 {
  margin-top: 10px;
}
</style>
